module.exports = __webpack_public_path__ + "img/18_77.88f37438.png";